import styled from 'styled-components'

export const Container = styled.div`
    background-color: darkcyan;
    text-align: center;
    color: white;
    font-weight: bold;
    padding: 4px 0px;
    text-shadow: 2px 2px 20px white;
`;